<template>
  <v-card flat hover>
    <v-card-text>
      <v-data-table
        hide-default-footer
        :items="indicacoes"
        no-data-text="Não há indicações"
        :headers="headers"
        show-expand
        :disable-sort="isMobile()"
        single-expand
      >
        <template v-slot:[`item.status`]="{ item }">
          <chip-status-indicacao
            :cores="item.cores"
            :label="item.desc_status"
          />
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <btn-corrigir-indicacao :indParam="item" v-if="item.pode_corrigir" />
          <span class="mr-1"></span>
          <btn-cancelar-indicacao :indicacao="item" v-if="!item.status_final" />
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length">
            <v-card flat class="mt-3 mb-3 grey lighten-4 rounded-md">
              <v-card-title class="subtitle-2 font-weight-bold"
                >Outras informações</v-card-title
              >
              <v-card-text>
                <v-row dense>
                  <v-col cols="12">
                    <p>
                      <span
                        >CPF: <b>{{ item.cpf }}</b>
                      </span>
                    </p>
                    <p>
                      <span
                        >Endereço: <b>{{ item.endereco }}</b>
                      </span>
                    </p>
                    <p>
                      <span
                        >Seu telefone de contato:
                        <b>{{ item.telefone_colaborador }}</b>
                      </span>
                    </p>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
            <btn-detalhes-indicacao :indicacao="item" />
          </td>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { dateFormat } from "@/global";
import ChipStatusIndicacao from "./ChipStatusIndicacao.vue";
import BtnCancelarIndicacao from "../buttons/BtnCancelarIndicacao.vue";
import BtnDetalhesIndicacao from "../buttons/BtnDetalhesIndicacao.vue";
import BtnCorrigirIndicacao from "../buttons/BtnCorrigirIndicacao.vue";

export default {
  props: {
    indicacoes: Array,
  },
  components: {
    ChipStatusIndicacao,
    BtnCancelarIndicacao,
    BtnDetalhesIndicacao,
    BtnCorrigirIndicacao,
  },
  data: () => ({
    dialog: false,
    headers: [
      { text: "ID", value: "id" },
      { text: "Nome CPD", value: "nome" },
      { text: "Dt Nasc", value: "dtnasc" },
      { text: "Cidade", value: "cidade" },
      { text: "Telefone", value: "telefone_pcd" },
      { text: "Status", value: "status" },
      { text: "", value: "actions", align: "end" },
    ],
  }),
  methods: {
    isMobile() {
      return this.$mq == "sm";
    },
    formatarData(value) {
      return dateFormat(value);
    },
    ultObs(ind) {
      return ind.movimentacao[ind.movimentacao.length - 1];
    },
  },
};
</script>

<style>
</style>